/** Short vibration on supported mobile browsers (no-op elsewhere). */
export function hapticLight(): void {
	try {
		if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
			navigator.vibrate(10);
		}
	} catch {
		/* ignore */
	}
}
